/**
 * @constant {lodash} _
 */

export { default as _ } from 'lodash';

/**
 * @namespace lang
 */

export * from './lang';

/**
 * @namespace array
 */

export * from './array';

/**
 * @namespace object
 */

export * from './object';

/**
 * @namespace collection
 */

export * from './collection';

/**
 * @namespace string
 */
export * from './string';

// compatibility
export * as text from './text';
export * as url from './url';
export * as naming from './naming';
